import { dismissEmptyPinSection } from 'app/utils/helpers';
import { useAppSelector } from 'app/store';
import { getCurrentProfileGuid } from 'app/store/Profile/selectors';
import { EmptyState } from './EmptyState';
import { PinnedSong } from './types';
import { PinnedSongsList } from './PinnedSongsList';
import { LoadingState } from './LoadingState';

interface PinnedSongsSectionContentProps {
  isFetching: boolean;
  data: PinnedSong[];
  setDissmissed: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PinnedSongsSectionContent = ({
  data,
  isFetching,
  setDissmissed,
}: PinnedSongsSectionContentProps) => {
  const profileGuid = useAppSelector(getCurrentProfileGuid);

  if (isFetching) {
    return <LoadingState />;
  }

  if (data.length === 0) {
    return (
      <EmptyState
        onClose={() => {
          setDissmissed(true);
          dismissEmptyPinSection(profileGuid);
        }}
      />
    );
  }

  return <PinnedSongsList data={data} />;
};
